import React from 'react';
import ReactDOM from 'react-dom/client';

import AccommodationSearchBlock from './AccommodationSearchBlock';

const root = ReactDOM.createRoot(
  document.getElementById('accommodation_search_block')
);

root.render(
  <React.StrictMode>
    <AccommodationSearchBlock />
  </React.StrictMode>
);
